import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";

import { compose } from 'recompose'
import { connect } from 'react-redux'
import { getTranslate } from "react-localize-redux";
import { Link } from 'react-router-dom'

// material-ui components
import withStyles from "material-ui/styles/withStyles";
import List from "material-ui/List";
import ListItem from "material-ui/List/ListItem";

import footerStyle from "assets/jss/material-dashboard-pro-react/components/footerStyle";

function Footer({ ...props }) {
  const { classes, fluid, white, translate } = props;

  var container = cx({
    [classes.container]: !fluid,
    [classes.containerFluid]: fluid,
    [classes.whiteColor]: white
  });
  var anchor =
    classes.a +
    cx({
      [" " + classes.whiteColor]: white
    });
  var block = cx({
    [classes.block]: true,
    [classes.whiteColor]: white
  })
  return (
    <footer className={classes.footer}>
      <div className={container}>
        <div className={classes.left}>
          <List className={classes.list}>
            <ListItem className={classes.inlineBlock}>
              <Link to={{ pathname: '/terms-and-conditions'}}>
                {translate("layout.footer.terms")}
              </Link>
            </ListItem>
            <ListItem className={classes.inlineBlock}>
              <Link to={{ pathname: '/privacy-policy'}}>
                {translate("layout.footer.privacy")}
              </Link>
            </ListItem>
          </List>
        </div>
        <p className={classes.right}>
          &copy; {1900 + new Date().getYear()}{" "}
          {translate("layout.footer.company")}
        </p>
      </div>
    </footer>
  );
}

Footer.propTypes = {
  classes: PropTypes.object.isRequired,
  fluid: PropTypes.bool,
  white: PropTypes.bool,
  rtlActive: PropTypes.bool
};

function mapStateToProps(state) {
  return {
    translate: getTranslate(state.localize)    
  };
}

export default compose(
  withStyles(footerStyle),
  connect(mapStateToProps, null)
)(Footer);



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.jsx